export default function (word, query) {
  if (query.length > 0) {
    const check = new RegExp(query, 'ig');
    return word.toString().replace(check, function (matchedText) {
      return '<em class="dsSearchHighlight--default">' + matchedText + '</em>';
    });
  }
  return word;
}
